<template>
  <v-combobox
    :value="value"
    dense
    outlined
    hide-no-data
    append-icon=""
    :hide-details="hideDetails"
    class="rmr-input"
    :class="{ 'rmr-input--md': size === 'md' }"
    v-bind="fieldAttrs"
    v-on="listeners"
  />
</template>

<script>
import { rmrChoiceFieldComputed } from "./build-rmr-choice-field-attrs";

export default {
  name: "RmrCombobox",
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      default: null,
    },
    hideDetails: {
      type: [Boolean, String],
      default: true,
    },
    size: {
      type: String,
      default: "sm",
      validator: (v) => ["sm", "md"].includes(v),
    },
  },
  computed: rmrChoiceFieldComputed,
};
</script>

<style lang="scss" scoped>
@import "./_rmr-input.scss";
</style>
